function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import angular from 'angular';
import { OpportunitiesModule } from '../core/opportunities.module';
import { Subject } from 'rxjs';
import { appSettings } from '../core/config.module';
import { getUrlComponents } from '../utilities/url';
import { ChildMessagePort } from '../utilities/messaging';
OpportunitiesModule.factory('globalIframeService', ["$logFactory", function ($logFactory) {
  "ngInject";

  return new GlobalIframeService($logFactory.get("globalIframeService"));
}]);
/**
 * A message port that always sends/receives data from the "current"
 * #autoalertiframe.
 *
 * This is necessary because three different components all create an
 * #autoalertiframe element, and they just happen to be mutually exclusive on
 * the page:
 *
 * - aaIframe
 * - legacyIframeSupport
 * - iframeModal
 *
 * Each of these components has coincidentally created an #autoalertiframe when
 * our page is expecting to be able to postMessage to that iframe.
 *
 * THIS IS A BACKWARDS-COMPATIBILITY UTILITY. We should gradually separate "the
 * iframe that is displaying a legacy page" and "the iframe that responds to
 * messages like GET_SSO_ID_TOKEN". We should have a single, hidden,
 * never-destroyed iframe that sends/receives all messages, and our app can
 * expose that one iframe as a service.
 */

var GlobalIframeService =
/*#__PURE__*/
function () {
  function GlobalIframeService($log) {
    _classCallCheck(this, GlobalIframeService);

    this._$log = $log;
    this._subscriptions = new Subject();

    this._subscriptions.subscribe(function (_ref) {
      var event = _ref.event,
          port = _ref.port;
      return $log.debug("Received", event.data, port);
    });
  }

  _createClass(GlobalIframeService, [{
    key: "setCurrentMessagePort",
    value: function setCurrentMessagePort(port, $scope) {
      var _this = this;

      this._port = port;
      var onMessageReceived;

      if ($scope) {
        onMessageReceived = function onMessageReceived(event) {
          return $scope.$apply(function () {
            return _this._subscriptions.next({
              event: event,
              port: port
            });
          });
        };
      } else {
        onMessageReceived = function onMessageReceived(event) {
          return _this._subscriptions.next({
            event: event,
            port: port
          });
        };
      }

      this._port.subscribe(onMessageReceived);
    }
  }, {
    key: "postMessage",
    value: function postMessage(data) {
      if (this._port) {
        this._$log.debug("Posting message", data);

        return this._port.postMessage(data);
      } else {
        this._$log.warn("Tried to post a message when no port is available");
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      return this._subscriptions.subscribe({
        next: function next(_ref2) {
          var event = _ref2.event,
              port = _ref2.port;
          return callback(event, port);
        }
      });
    }
  }]);

  return GlobalIframeService;
}();